module.exports = __webpack_public_path__ + "static/media/store.tele724.83eba099.png";